export const dedupeLikes = (likes = []) => {
  if (!Array.isArray(likes)) return [];
  const seen = new Set();
  let changed = false;
  const result = [];
  for (const like of likes) {
    if (!like) { changed = true; continue; }
    if (seen.has(like)) { changed = true; continue; }
    seen.add(like);
    result.push(like);
  }
  return changed ? result : likes;
};

export const normalizeSong = (song) => {
  if (!song) return song;
  const likes = dedupeLikes(song.likes);
  return likes === song.likes ? song : { ...song, likes };
};
